import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const initialState = {
    isLoading: false,
    error: null,
    stylists: [],
  };


  const slice = createSlice({
    name: 'stylists',
    initialState,
    reducers: {
      // START LOADING
      startLoading(state) {
        state.isLoading = true;
      },
  
      // HAS ERROR
      hasError(state, action) {
        state.isLoading = false;
        state.error = action.payload;
      },
    
      getStylistsSuccess(state, action) {
        state.isLoading = false;
        state.stylists = action.payload;
      },

      addStylistSuccess(state, action) {
        const newStylist = action.payload; 
        state.isLoading = false;
      },

      updateStylistSuccess(state, action) {
        state.isLoading = false;
      },

      deleteStylistSuccess(state, action) {
        state.isLoading = false;
      },

      getStylistSchedulesSuccess(state, action) {
        state.isLoading = false;
      },

      updateStylistScheduleSuccess(state, action) {
        state.isLoading = false;
      },

    },
  });

  // Reducer
  export default slice.reducer;
  

  
  // ----------------------------------------------------------------------
  

  export function getAllStylists(){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.get('/api/stylists');
        dispatch(slice.actions.getStylistsSuccess(response.data.stylists || []));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }

  export function addStylist(data){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.post('/api/stylists',data);
        dispatch(slice.actions.addStylistSuccess(response.data));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }

  export function updateStylist(id,data){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.put(`/api/stylists/${id}`,data);
        dispatch(slice.actions.updateStylistSuccess(response.data));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }

  export function deleteStylist(id){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.delete(`/api/stylists/${id}`);
        dispatch(slice.actions.deleteStylistSuccess(response.data));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }

  export function getStylistSchedules(stylistId){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.get(`/api/stylist-schedules/stylist/${stylistId}`);
        dispatch(slice.actions.getStylistSchedulesSuccess(response.data));
        return response.data;
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
        return null;
      }
    }
  }

  export function updateStylistSchedule(stylistId, weeklySchedule){
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try{
        const response = await axios.post('/api/stylist-schedules', {
          stylistId,
          weeklySchedule
        });
        dispatch(slice.actions.updateStylistScheduleSuccess(response.data));
      }
      catch(error){
        dispatch(slice.actions.hasError(error));
        throw error;
      }
    }
  }
